import { useState, useCallback, useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { DonateContext, Marquee } from "@/components/gala/shared";
import DonateModal from "@/components/gala/DonateModal";
import Navbar from "@/components/gala/Navbar";
import Hero from "@/components/gala/Hero";
import Countdown from "@/components/gala/Countdown";
import Campaign from "@/components/gala/Campaign";
import Mission from "@/components/gala/Mission";
import Children from "@/components/gala/Children";
import AdultProm from "@/components/gala/AdultProm";
import Chicago from "@/components/gala/Chicago";
import Timeline from "@/components/gala/Timeline";
import Tickets from "@/components/gala/Tickets";
import Sponsorship from "@/components/gala/Sponsorship";
import AfterParty from "@/components/gala/AfterParty";
import SocialWall from "@/components/gala/SocialWall";
import FinalCTA from "@/components/gala/FinalCTA";
import Footer from "@/components/gala/Footer";
import StickyCTA from "@/components/gala/StickyCTA";

function App() {
  const [donateOpen, setDonateOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const openDonate = useCallback((amount = null) => {
    setPrefill(amount);
    setDonateOpen(true);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <DonateContext.Provider value={{ openDonate }}>
      <div className="App bg-ink text-ivory overflow-x-clip">
        <Toaster theme="dark" position="top-center" richColors />
        <Navbar />
        <main>
          <Hero />
          <Countdown />
          <Marquee
            items={[
              "Dress Up",
              "Show Up",
              "Give Big",
              "Building Crowns 4 The Future",
              "Adult Prom for a Purpose",
              "November 7, 2026",
            ]}
          />
          <Campaign />
          <Mission />
          <Children />
          <AdultProm />
          <Chicago />
          <Timeline />
          <Tickets />
          <Sponsorship />
          <AfterParty />
          <SocialWall />
          <FinalCTA />
        </main>
        <Footer />
        <StickyCTA />
        <DonateModal open={donateOpen} prefill={prefill} onClose={() => setDonateOpen(false)} />
      </div>
    </DonateContext.Provider>
  );
}

export default App;
